export default __webpack_public_path__ + "static/dg-6f63b8483ecc9d2a0eaba9d57693c421.svg";